module.exports = __webpack_public_path__ + "static/media/c3.d5dd6ec2.png";